import { APIPersonalAutoApplicationFormVehicle } from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';

export const processLeasedVehicleData = (
  vehicles: APIPersonalAutoApplicationFormVehicle[],
): BinderSectionData => {
  const processedLeasedVehicleData = {
    vehicles: vehicles.map((vehicle, index: number) => {
      const isLeased = vehicle?.is_leased || false;
      const lessorObj = vehicle?.lessor;

      return {
        index: index + 1,
        name:
          vehicle?.make && vehicle?.model
            ? `${vehicle.make} ${vehicle.model}`
            : `Vehicle ${index + 1}`,
        isLeased,
        lessor: lessorObj,
        isValid: !isLeased,
      };
    }),
  };

  // Overall leased vehicle validation - all leased vehicles must have lessors
  const isLeasedVehicleValid = processedLeasedVehicleData.vehicles.every(
    (vehicle) => vehicle.isValid,
  );
  const leasedVehicleMessage = !isLeasedVehicleValid
    ? 'One or more leased vehicles are missing lessor information'
    : null;

  return {
    title: 'Missing lessor',
    description: 'Check to see that each leased vehicle has a lessor defined.',
    isValid: isLeasedVehicleValid,
    message: leasedVehicleMessage,
    data: processedLeasedVehicleData,
  };
};
